import { useEffect } from "react";
import { useRouter } from "next/router";
import { withAuthUser } from "next-firebase-auth";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useAuth } from "@/components/auth/hooks/useAuth";
import { useTranslation } from "next-i18next";
// BOOTSTRAP
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
// COMPONENTS
import BootstrapSpinner from "@/components/elements/LoadingPlaceholders/BootstrapSpinner";
import SideLinks from "@/components/core/CustomerService/SideLinks/SideLinks";
import { NextSeo } from "next-seo";
// i18n

function TermsAndConditions() {
  const { t } = useTranslation("terms-and-conditions");

  const router = useRouter();
  const auth = useAuth();

  // If the user is not allowed will be redirect to homepage.
  useEffect(() => {
    if (auth.isUserSupplier()) {
      router.push("/home-supplier");
    }
  }, [[], auth]);

  return auth.isUserSupplier() ? (
    <BootstrapSpinner />
  ) : (
    <Container fluid className="px-0">
      <NextSeo
        title={t("terms-and-conditions")}
        description={""}
        openGraph={{
          type: "website",
          title: t("terms-and-conditions"),
          description: "",
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/terms-and-conditions`,
        }}
      />
      <Row key="catalogPage" className="mx-0 px-3">
        <SideLinks />
        <Col className="px-0 px-lg-5" style={{ maxWidth: "80rem" }}>
          <h1 className="fs-1 fw-semibold text-center text-md-start text-uppercase pb-5">{t("terms-and-conditions")}</h1>
          <div className="py-1">
            <h2 className="fs-6 fs-6 fw-semibold pb-2">{t("section-1.title")}</h2>
            <p>{t("section-1.p1")}</p>
            <p>{t("section-1.p2")}</p>
            <p>{t("section-1.p3")}</p>
            <p>{t("section-1.p4")}</p>
            <p>{t("section-1.p5")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-2.title")}</h2>
            <p>{t("section-2.p1")}</p>
            <p>{t("section-2.p2")}</p>
            <p>{t("section-2.p3")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-3.title")}</h2>
            <p>{t("section-3.p1")}</p>
            <p>{t("section-3.p2")}</p>
            <p>{t("section-3.p3")}</p>
            <p>{t("section-3.p4")}</p>
            <p>{t("section-3.p5")}</p>
            <p>{t("section-3.p6")}</p>
            <p>{t("section-3.p7")}</p>
            <p>{t("section-3.p8")}</p>
            <p>{t("section-3.p9")}</p>
            <p>{t("section-3.p10")}</p>
            <p>{t("section-3.p11")}</p>
            <p>{t("section-3.p12")}</p>
            <p>{t("section-3.p13")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-4.title")}</h2>
            <p>{t("section-4.p1")}</p>
            <p>{t("section-4.p2")}</p>
            <p>{t("section-4.p3")}</p>
            <p>{t("section-4.p4")}</p>
            <p>{t("section-4.li1")}</p>
            <p>{t("section-4.li2")}</p>
            <p>{t("section-4.li3")}</p>
            <p>{t("section-4.li4")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-5.title")}</h2>
            <p>{t("section-5.p1")}</p>
            <p>{t("section-5.p2")}</p>
            <p>{t("section-5.p3")}</p>
            <p>{t("section-5.p4")}</p>
            <p>{t("section-5.p5")}</p>
            <p>{t("section-5.p6")}</p>
            <p>{t("section-5.p7")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-6.title")}</h2>
            <p>{t("section-6.p1")}</p>
            <p>{t("section-6.p2")}</p>
            <p>{t("section-6.p3")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-7.title")}</h2>
            <p>{t("section-7.p1")}</p>
            <p>{t("section-7.p2")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-8.title")}</h2>
            <p>{t("section-8.p1")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-9.title")}</h2>
            <p>{t("section-9.p1")}</p>
            <p>{t("section-9.p2")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-10.title")}</h2>
            <p>{t("section-10.p1")}</p>
            <p>{t("section-10.p2")}</p>
            <p>
              <span>{t("section-10.p3")}</span>{" "}
              <a target="_blank" rel="noreferrer" href="http://ec.europa.eu/odr">
                {t("section-10.a")}
              </a>
            </p>

            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-11.title")}</h2>
            <p>{t("section-11.p1")}</p>
            <p>{t("section-11.p2")}</p>
            <p>{t("section-11.p3")}</p>
            <hr />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "header",
        "footer",
        "customer-service",
        "services-side-links",
        "terms-and-conditions",
        "db-translations",
      ])),
    },
  };
}

export default withAuthUser({})(TermsAndConditions);
